import options from '@/options'

export default {
  filters: {
    LOCALE_: (key) => options.LOCALES.find((s) => s.key === key)?.value || key,
    SHORT_ID_: (id) => (id ? String(id).slice(-5, id.length).toUpperCase() : null),
    CAPITALIZE_: (str) => str.charAt(0).toUpperCase() + str.slice(1),
    SOURCE_: (key) => options.GENERAL_SOURCES.find((s) => s.key === key)?.value || key,
    PROJECT_STATUS_: (key) => options.PROJECT_STATUS.find((s) => s.key === key)?.value || key,
    PROJECT_STATUS_COLOR_: (key) => options.PROJECT_STATUS.find((s) => s.key === key)?.color || key,
    SERVICE_: (key) => options.SERVICE_TYPES.find((s) => s.key === key)?.value || key,
    SERVICE_LOCALE_: (key, locale) => options.SERVICE_TYPES.find((s) => s.key === key)?.locales[locale] || key,
    PROPERTY_: (key) => options.PROPERTY_TYPES.find((s) => s.key === key)?.value || key,
    CONTRACTOR_TYPE_: (key) => options.CONTRACTOR_TYPES.find((s) => s.key === key)?.value || key,
    DEPARTMENT_: (key) => options.DEPARTMENT.find((s) => s.key === key)?.value || key,
    JOB_TITLE_: (key) => options.JOB_TITLES.find((s) => s.key === key)?.value || key,
    CAMPAIGN_STATUS_: (key) => options.CAMPAIGN_STATUS.find((s) => s.key === key)?.value || key,
    CAMPAIGN_STATUS_COLOR_: (key) => options.CAMPAIGN_STATUS.find((s) => s.key === key)?.color || key,
  },
  data() {
    return {
      status_: 'pending',
      options_: options,
    }
  },
  methods: {
    statusClass: (status) => {
      switch (status) {
        case 'active':
          return 'badge-primary'
        case 'inactive':
          return 'badge-danger'
        case 'pending':
          return 'badge-default'
        default:
          return 'badge-default'
      }
    },

    debounce: (fn, delay) => {
      let timeout
      return function (...args) {
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(() => {
          fn(...args)
        }, delay)
      }
    },
  },
}
